import serverArr from "@/api/servers";
import sdkUrl from "@/api/sdkurl";

const webConfig =  {
    //应用名称
    appName: "造梦游戏",
    //应用名称
    gameAppName: "造梦游戏",
    //应用图标
    logoUrl: require("@/assets/logo.png"),
    //圆形logo
    logoRoundUrl: require("@/assets/logo-round.png"),
    //微信公众号
    wechatUrl: "",
    //应用二维码
    appqrUrl: "",
    //icp备案
    icp: "豫ICP备2026001905号-1",
    //公安备案
    publicSecurity: "",
    //版权所有
    copyright: "copyright © 2026 zaomeng.cc/ All Rights Resered.",
    //公司地址
    address: "河南省信阳市潢川县弋阳街道物流港东方珑熙府6号楼302室",
    //公司名称
    companyName: "信阳游核引擎科技有限公司",
    //公司名称
    copyrightCompany: "游核引擎 版权所有",
    //用户协议
    agreement :  "https://game.zaomeng.cc/static/agreement/user.html",
    //隐私政策
    privacy :  "https://game.zaomeng.cc/static/agreement/privacy.html",
    //QQ客服
    qqkfList: [
        // {"info": "", "worktime": ""}
    ],
    wxkfList: [
        {"info": "", "worktime": "09:00-22:00"}
    ],
    telkfList: [
        // {"info": "", "worktime": ""}
    ],
    //平台币名称
    coinName: "造梦币",
    bindCoinName: '绑币',
    //游戏加速器地址
    speedUrl: "https://game.zaomeng.cc/static/speed/a.html?genCode=true",
    //sdkweb地址
    sdkUrl: sdkUrl,
    //默认搜索游戏名
    defaultSearchName: "斗罗大陆",
    hotSearchName: ["斗罗大陆"],
    redirectUri: "https://game.zaomeng.cc/#/selfPayWX",
    appid: "wxefd8fe7ad90d0539",
    //抽奖活动地址
    drawUrl: 'https://game.zaomeng.cc/draw',
}

export default webConfig